import * as React from 'react';

import * as styles from './SingleContactWrapper.css';

export const SingleContactWrapper = ({ children }: React.PropsWithChildren) => {
  return <div className={styles['container']}>{children}</div>;
};
